import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemExternalUrlSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const projectId = state.project.activeProject?.id

    if (bomItemId === projectId) {
      return state.project.activeProject.externalUrl
    }

    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem.type === 'MaterialHeader' || bomItem.type === 'RoutingHeader') {
      throw Error('material header does not have external url')
    }

    return bomItem.externalUrl
  }
